import React, { useState, useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { TooltipManager, TooltipPopper } from '../../../Tooltip';
import DeviationFlagBase from './DeviationFlagBase';
import DailyDeviationFlag from './DailyDeviationCard';
import { MobileContext } from '../../../Context';
import s from './DeviationFlags.scss';
var DeviationFlags = function (_a) {
    var dailyDeviation = _a.deviation.dailyDeviation, alwaysExpanded = _a.alwaysExpanded, disableLabel = _a.disableLabel;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    // TODO: this visibility juggling is a good candidate for reducer conversion
    var _b = useState(false), isFlagListVisible = _b[0], setFlagListVisible = _b[1];
    var _c = useState(false), isHovering = _c[0], setHovering = _c[1];
    var show = function () {
        setFlagListVisible(true);
        setHovering(true);
    };
    var hide = function () { return setHovering(false); };
    var toggle = isFlagListVisible ? show : hide;
    if (!dailyDeviation) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], alwaysExpanded && s['always-expanded'], isHovering && s['hovering'], disableLabel && s['disable-label']), onClick: isMobile ? toggle : undefined, onMouseEnter: isMobile ? undefined : show, onMouseLeave: isMobile ? undefined : hide, onTransitionEnd: function (e) {
            if (e.propertyName === 'opacity' && !isHovering) {
                setFlagListVisible(false);
            }
        } },
        React.createElement(TooltipManager, { renderReference: function (_a) {
                var ref = _a.ref;
                return (React.createElement(DeviationFlagBase, { innerRef: ref, title: t("actionbar.flags.dailyDeviation") }));
            } },
            React.createElement(TooltipPopper, { className: s['tooltip'], placement: isMobile ? 'top-end' : 'top-start', eventsEnabled: isFlagListVisible, positionOnly: true, renderTooltipContent: function (_a) {
                    var placement = _a.placement;
                    return (React.createElement("div", { className: classnames(s['flag-list'], s[placement], isFlagListVisible && s['flag-list-visible']) },
                        React.createElement(DailyDeviationFlag, { dailyDeviation: dailyDeviation })));
                } }))));
};
DeviationFlags.displayName = 'DeviationFlags';
export default DeviationFlags;
//# sourceMappingURL=DeviationFlags.js.map